import {
  titleLengthHelper,
  titleScoreWeights,
  titleScoreWeightsWithCompetitor,
} from "./h1Helper";
import {
  computeCorrectScore,
  findMatches,
  getText,
  removeAccents,
  removeStopWords,
} from "./helper";

// Target Keyword Included Check
const targetKeywordAnalysis = (formikProps) => {
  let h1 = getText(formikProps.values.h1_title.trim());
  if (h1.length == 0) {
    return -1;
  }

  if (!formikProps.values.seo_request.trim()) {
    return { score: 0, percentage: 0 };
  }
  const seoRequest = getText(formikProps.values.seo_request.trim())
    .toLowerCase()
    .split(" ");
  let count = 0;

  seoRequest.forEach((word) => {
    const matches = findMatches(h1, word);

    if (matches) {
      count += 1;
    }
  });
  if (count == 0) {
    return 0;
  } else {
    if (count > seoRequest.length) {
      return 100;
    }
    return (count / seoRequest.length) * 100;
  }
};

// Length Check
const titleLength = (formikProps) => {
  if (formikProps.values.h1_title.trim().length == 0) {
    return { score: -1, percentage: 0, charCount: 0, wordCount: 0 };
  }
  const wordCount = getText(formikProps.values.h1_title.trim()).split(
    " "
  ).length;
  const charCount = getText(formikProps.values.h1_title.trim()).length;
  return titleLengthHelper(charCount, wordCount);
};

// Appearance Count Check
const appearanceCount = (formikProps) => {
  if (getText(formikProps.values.h1_title.trim()).length == 0) {
    return { score: -1, h1Tags: 0 };
  }
  const d = formikProps.values.content;
  const content_matches = [...d.matchAll(/<h(\d)>(.*?)<\/h\1>/g)].map(
    (match) => `h${match[1]}`
  );
  const conclusion = formikProps.values.conclusion;
  const conclusion_matches = [
    ...conclusion.matchAll(/<h(\d)>(.*?)<\/h\1>/g),
  ].map((match) => `h${match[1]}`);
  const introduction = formikProps.values.introduction;
  const introduction_matches = [
    ...introduction.matchAll(/<h(\d)>(.*?)<\/h\1>/g),
  ].map((match) => `h${match[1]}`);

  const matches = content_matches.concat(
    conclusion_matches,
    introduction_matches
  );

  const h1Tags = matches.filter((x) => x.includes("h1")).length;
  if (h1Tags == 0) {
    return { score: 100, h1Tags: 0 };
  } else {
    return { score: 0, h1Tags: h1Tags };
  }
};

// Duplicate Check
const duplicateCheck = (formikProps) => {
  if (getText(formikProps.values.h1_title.trim()).length == 0) {
    return -1;
  }
  let words = removeAccents(
    removeStopWords(getText(formikProps.values.h1_title.trim()))
  ).split(" ");

  let res = [];
  for (let i = 0; i < words.length; i++) {
    if (words.indexOf(words[i]) !== i) {
      res.push(words[i]);
    }
  }

  if (res.length == 0) {
    return 100;
  }
  if (res.length == 1) {
    return 50;
  }
  if (res.length > 1) {
    return 0;
  }
};

// Uniqueness
const unqiueTitle = (formikProps, competitorResult) => {
  const title = getText(formikProps.values.h1_title.trim()).toLowerCase();
  if (title.length == 0) {
    return -1;
  }

  return competitorResult?.contents?.find(
    (item) => item.h1_title.toLowerCase() === title
  )
    ? 0
    : 100;
};

// Score Calculation
export const startH1Analysis = (formikProps, competitorResult) => {
  const keywordCount = targetKeywordAnalysis(formikProps);
  const lengthCheck = titleLength(formikProps);
  const appearance = appearanceCount(formikProps);
  const duplicate = duplicateCheck(formikProps);
  let scoreArr = [keywordCount, duplicate, appearance.score, lengthCheck.score];
  var uniqueness = null;
  let totalScore = computeCorrectScore(scoreArr, titleScoreWeights);

  if (competitorResult) {
    uniqueness = unqiueTitle(formikProps, competitorResult);
    scoreArr.push(uniqueness);
    totalScore = computeCorrectScore(scoreArr, titleScoreWeightsWithCompetitor);
  }

  return {
    keyword_score: keywordCount,
    title_length: lengthCheck,
    appearance_count: appearance,
    duplicate_check: duplicate,
    uniqueness: uniqueness,
    total_score: Math.round(totalScore),
  };
};
